const getOrderStatus = (status, deliveryType) => {
  var statusText = "";

  switch (status.toLowerCase()) {
    case "payment_expected":
      statusText = "Order Submitted!";

      break;

    case "payment_successful":
      statusText = "Order Submitted!";

      break;

    case "order_check_timeout":
      statusText = "Cancelled";

      break;

    case "payment_timeout":
      statusText = "Cancelled";

      break;

    case "payment_failed":
      statusText = "Cancelled";

      break;

    case "order_denied":
      statusText = "Order declined";

      break;

    case "order_accepted_with_additional_time_user_confirm_expected":
      statusText = "Accepted with new time";

      break;

    case "order_additional_time_denied_by_user":
      statusText = "Cancelled by customer";

      break;

    case "order_accepted_with_additional_time_restaurant_confirm_expected":
      statusText = "Order being prepared!";

      break;

    case "order_accepted":
      statusText = "Order being prepared!";

      break;

    case "order_preparing":
      statusText = "Order being prepared!";

      break;

    case "order_prepared":
      statusText =
        (deliveryType === "DELIVERY" && "Order being prepared!") ||
        "Waiting for Collection";

      break;

    case "order_in_driver":
      statusText = "Yay! Food is on its way!";

      break;

    case "order_completed":
      statusText = "Completed";

      break;

    case "order_canceled_and_full_refund_before_completed":
      statusText = "Refunded";
      break;

    default:
      statusText = "Status Not Found";
  }

  return statusText;
};

export default getOrderStatus;
